import { render, staticRenderFns } from "./CadastralMap.vue?vue&type=template&id=535cd91a&scoped=true&"
import script from "./CadastralMap.vue?vue&type=script&lang=js&"
export * from "./CadastralMap.vue?vue&type=script&lang=js&"
import style0 from "./CadastralMap.vue?vue&type=style&index=0&id=535cd91a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535cd91a",
  null
  
)

export default component.exports